export default __webpack_public_path__ + "3b63ccd5fe8fe756ffca95f4a6606a12.svg";